/**
 * Shared navigation labels for BHYVE rail and classic Materio sidebar.
 * Keep in sync — both shells read from here.
 */
export const GYG_NAV_LABELS = {
  restaurants: 'Restaurants',
  restaurantAllocation: 'Restaurant Allocation',
  permanentDisableRequests: 'Permanent Disable Requests',
  reporting: 'Reporting',
  disabledIngredients: 'Disabled Ingredients',
  disabledEquipments: 'Disabled Equipments',
  weeklyDisabledIngredientsReport: 'Weekly Disabled Ingredients Report',
  weeklyChangesReport: 'Weekly Changes Report',
  operationalReports: 'Operational Reports',
  marketing: 'Marketing',
  restaurantSurcharges: 'Restaurant Surcharges',
  foodGuide: 'Food Guide',
  recipes: 'Recipes',
  recipeEquipment: 'Equipment',
  howToGuides: 'How to Guides',
  howToGuide: 'How to Guide',
  quickReference: 'Quick Reference',
  restaurantEquipment: 'Restaurant Equipment',
  restaurantPlus: "Restaurant PLU's",
  users: 'Users',
  guestExperience: 'Guest Experience',
  franchiseeHub: 'Franchisee Hub',
  wasteLog: 'Waste Logging',
  cashCount: 'Cash Count',
  emailAuditLog: 'Audit Log Notification',
  communicationsAndHelp: 'Comms & Help',
  menuConfig: 'Menu Config',
  adminTools: 'Admin Tools'
} as const
